import { render, staticRenderFns } from "./startup.vue?vue&type=template&id=3be320c7&scoped=true"
import script from "./startup.vue?vue&type=script&lang=js"
export * from "./startup.vue?vue&type=script&lang=js"
import style0 from "./startup.vue?vue&type=style&index=0&id=3be320c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be320c7",
  null
  
)

export default component.exports